import { observable, makeObservable } from 'mobx';

export default class DataMixin<T, S> {
  store: S;

  api: T;

  @observable isLoaded = false;

  @observable isFailure = false;

  constructor(rootStore: S, api: T) {
    makeObservable(this);
    this.store = rootStore;
    this.api = api;
  }

  reset(): void {
    this.isFailure = false;
    this.isLoaded = false;
  }
}
